const id_master_courier = {
    add: "tambah kurir",
    edit: "ubah kurir",
    name: "nama kurir",

    error: {
        create: "Gagal membuat kurir.",
        delete: "Gagal menghapus kurir.",
        edit: "Gagal mengubah kurir.",
        user: "Pengguna tidak boleh kosong.",
    },

    success: {
        create: "Berhasil membuat kurir.",
        delete: "Berhasil menghapus kurir.",
        edit: "Berhasil mengubah kurir.",
    }
}

export default id_master_courier;